import { useNavigate } from "react-router-dom";
import AllRoleManagement from "./modules/RoleManagement";
import { PageTitle } from "../modules/PageHeaders";
import { ButtonComp } from "../../../components";

export default function SettingRoleManagement() {
  const navigate = useNavigate();
  const TableDropDown = [
    {
      name: "Edit",
      action: (data) => {
        if (data?.is_system) return;
        navigate(`/super_admin/settings/role_management/${data.id}/edit`);
      },
      disabled: (data) => Boolean(data?.is_system),
    },
  ];

  return (
    <section className="px-2 px-lg-4 min-vh-100">
      <div className="py-1"></div>
      <div className="mb-4 d-flex justify-content-between align-items-center flex-wrap gap-2">
        <PageTitle title={"Role Management"} />
        <ButtonComp
          btnText={"Create role"}
          onClick={() => navigate("new")}
          btnClassName={"bg-primary1 text-white border-0 rounded px-4 py-2"}
        />
      </div>
      <AllRoleManagement
        TableDropDown={TableDropDown}
        onSubmit={() => navigate("new")}
        emptyTable="No roles have been created yet"
      />
    </section>
  );
}
